module.exports = __webpack_public_path__ + "img/poweredbylogo.a78c6ff2.png";